import React from 'react';
import { timelineColors, timelineFontWeight } from './tokens';

export const MoreBadge = React.memo(
  ({
    x,
    y,
    count,
    belowIcon,
    onClick
  }: {
    x: number;
    y: number;
    count: number;
    // With labels hidden the badge sits beside the icon instead of below it.
    belowIcon: boolean;
    onClick: () => void;
  }) => (
    <div
      onClick={onClick}
      style={{
        position: 'absolute',
        left: x + 14,
        top: belowIcon ? y + 10 : y - 9,
        background: timelineColors.ink,
        color: timelineColors.surface,
        fontSize: 10,
        fontWeight: timelineFontWeight.label,
        padding: '2px 7px',
        borderRadius: 9,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        zIndex: 3,
        lineHeight: '14px'
      }}
    >
      +{count} more
    </div>
  )
);
